import { useState } from "react";
import mkcgLogo from "../assests/logo/logo.png";
import { Link } from "react-router-dom";

const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5001/api";

/* ─────────────────────────────────────────────────────────────
   Main Component
───────────────────────────────────────────────────────────── */

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [dob, setDob] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const e = {};

    if (!email) {
      e.email = "Email address is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      e.email = "Enter a valid email address.";
    }

    if (!dob) {
      e.dob = "Date of birth is required.";
    }

    return e;
  };

  const handleChange = (field, val) => {
    if (field === "email") setEmail(val);
    if (field === "dob") setDob(val);

    if (errors[field] || errors.form) {
      setErrors((prev) => ({
        ...prev,
        [field]: undefined,
        form: undefined,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrors({});

    const errs = validate();

    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(
        `${API_URL}/student/forgot-password/verify`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            dob,
          }),
        }
      );

      const data = await response.json();

      setLoading(false);

      if (data.success) {
        // Keep the short-lived reset token only for the reset step
        sessionStorage.setItem("resetToken", data.resetToken);

        window.location.href = "/reset-password";
      } else {
        setErrors({
          form:
            data.message ||
            "Email or Date of Birth does not match our records.",
        });
      }
    } catch (err) {
      setLoading(false);

      console.error(err);

      setErrors({
        form: "Cannot connect to server. Please try again.",
      });
    }
  };

  return (
    <>
      <style>{css}</style>

     <div className="ig-page">
     
             {/* ───────────────── TOP NAVBAR ───────────────── */}
             <header className="ig-navbar">
     
               <div className="ig-navbar-left">
     
                 <img
                   className="logo-image"
                   src={mkcgLogo}
                   alt="MKCG Medical College"
                 />
     
                 <div className="ig-navbar-titles">
     
                   <h1 className="ig-navbar-title">
                     MKCG MEDICAL COLLEGE, BRAHMAPUR, ODISHA, INDIA
                   </h1>
     
                   <p className="ig-navbar-subtitle">
                     ମହାରାଜା କୃଷ୍ଣଚନ୍ଦ୍ର ଗଜପତି ଭେଷଜ ମହାବିଦ୍ୟାଳୟ, ବ୍ରହ୍ମପୁର, ଓଡ଼ିଶା, ଭାରତ
                   </p>
     
                 </div>
               </div>
     
               <div className="ig-navbar-right">
     
                 <span className="ig-navbar-badge">
                   STUDENT INTERFACE
                 </span>
     
                 <Link
                   to="/"
                   className="ig-home-btn"
                 >
                   Return to Home
                 </Link>
     
               </div>
     
             </header>

        {/* ───────────── Main ───────────── */}
        <main className="fp-main">

          <div className="fp-card">

            {/* Card title */}
            <div className="fp-card-header">
              <span>FORGOT PASSWORD</span>
            </div>

            {/* Icon */}
            <div className="fp-icon-wrap">

              <div className="fp-icon-ring" />

              <div className="fp-icon">

                <svg
                  width="42"
                  height="42"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#184381"
                  strokeWidth="1.7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect
                    x="3"
                    y="11"
                    width="18"
                    height="10"
                    rx="2"
                  />

                  <path d="M7 11V7a5 5 0 0110 0v4" />

                  <circle
                    cx="12"
                    cy="16"
                    r="1"
                  />

                  <path d="M12 17v2" />
                </svg>

              </div>

            </div>

            {/* Description */}
            <div className="fp-description">

              <h2>Reset Your Password</h2>

              <p>
                Enter your registered email address and date of birth
                to verify your identity.
              </p>

            </div>

            {/* Error */}
            {errors.form && (
              <div className="fp-login-error">

                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line
                    x1="12"
                    y1="16"
                    x2="12.01"
                    y2="16"
                  />
                </svg>

                <span>{errors.form}</span>

              </div>
            )}

            {/* Form */}
            <form
              onSubmit={handleSubmit}
              noValidate
              className="fp-form"
            >

              {/* Email */}
              <div className="fp-field">

                <label className="fp-label">
                  Mail ID <span>*</span>
                </label>

                <div
                  className={`fp-input-wrap${
                    errors.email ? " fp-err" : ""
                  }`}
                >

                  <svg
                    className="fp-input-icon"
                    width="17"
                    height="17"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>

                  <input
                    type="email"
                    placeholder="Enter your registered email"
                    value={email}
                    onChange={(e) =>
                      handleChange("email", e.target.value)
                    }
                    autoComplete="email"
                  />

                </div>

                {errors.email && (
                  <p className="fp-error-msg">
                    ⚠ {errors.email}
                  </p>
                )}

              </div>

              {/* Date of Birth */}
              <div className="fp-field">

                <label className="fp-label">
                  Date of Birth <span>*</span>
                </label>

                <div
                  className={`fp-input-wrap${
                    errors.dob ? " fp-err" : ""
                  }`}
                >

                  <svg
                    className="fp-input-icon"
                    width="17"
                    height="17"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <rect
                      x="3"
                      y="4"
                      width="18"
                      height="18"
                      rx="2"
                    />

                    <line
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="6"
                    />

                    <line
                      x1="8"
                      y1="2"
                      x2="8"
                      y2="6"
                    />

                    <line
                      x1="3"
                      y1="10"
                      x2="21"
                      y2="10"
                    />

                    <line
                      x1="8"
                      y1="14"
                      x2="8"
                      y2="14"
                    />

                    <line
                      x1="12"
                      y1="14"
                      x2="12"
                      y2="14"
                    />

                    <line
                      x1="16"
                      y1="14"
                      x2="16"
                      y2="14"
                    />

                  </svg>

                  <input
                    type="date"
                    value={dob}
                    onChange={(e) =>
                      handleChange("dob", e.target.value)
                    }
                  />

                </div>

                {errors.dob && (
                  <p className="fp-error-msg">
                    ⚠ {errors.dob}
                  </p>
                )}

              </div>

              {/* Verify button */}
              <div className="fp-action-row">

                <button
                  type="submit"
                  className="fp-submit"
                  disabled={loading}
                >

                  {loading ? (
                    <span className="fp-btn-spinner" />
                  ) : (
                    <>
                      Verify
                      <span>→</span>
                    </>
                  )}

                </button>

              </div>

              {/* Divider */}
              <div className="fp-divider" />

              {/* Back to login */}
              <p className="fp-login-line">

                Remembered your password?{" "}

                {/* <a
                  href="/student-login"
                  className="fp-login-link"
                >
                  Back to Login
                </a> */}

                <Link
                  to="/StudentLogin"
                  className="fp-login-link"
                >
                  Back to Login
                </Link>

              </p>

            </form>

          </div>

        </main>

        {/* ───────────── Footer ───────────── */}
        <footer className="fp-footer">

          <span>
            ALL RIGHTS RESERVED BY: MKCG MEDICAL COLLEGE{" "}
            {new Date().getFullYear()}
          </span>

          <span>
            POWERED BY:{" "}
            <span className="fp-footer-brand">
              Orisys Infotech
            </span>
          </span>

        </footer>

      </div>
    </>
  );
}


/* ═══════════════════════════════════════════════════════════════
   CSS
═══════════════════════════════════════════════════════════════ */

const css = `

@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Noto+Sans+Odia&display=swap');


*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}


:root {
  --navy: #184381;
  --navy-light: #2b68c3;

  --blue: #184381;
  --blue-dark: #123566;
  --blue-light: #2b68c3;

  --panel-border: #E4EAF3;
  --field-bg: #F5F8FC;

  --text-primary: #0F2A44;
  --text-muted: #6B7C93;

  --error: #E4483C;
}



/* ═══════════════════════════════════════════════
   IMPORTANT TYPOGRAPHY
═══════════════════════════════════════════════ */

.ig-page,
.ig-page button,
.ig-page input,
.ig-page select,
.ig-page textarea {

  font-family:
   'Noto Sans', Arial, sans-serif;

}


/* Main normal text */
.ig-page {

  min-height: 100vh;

  font-size: 0.9rem;

  font-weight: 400;

  line-height: 1.5;

  color: var(--text);

  background: #EEF2F7;

}


/* ═══════════════════════════════════════════════
   TOP NAVBAR
═══════════════════════════════════════════════ */

.ig-navbar {

  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 1rem;

  background: #023c77ff;

  color: #fff;

  padding: 0.65rem 1.5rem;

  box-shadow:
    0 2px 10px rgba(0, 0, 0, 0.25);

}


.ig-navbar-left {

  display: flex;

  align-items: center;

  gap: 0.85rem;

}


.logo-image {

  height: 55px;

  width: auto;

  object-fit: contain;

}


.ig-navbar-titles {

  line-height: 1.25;

}


.ig-navbar-title {

  margin: 0;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 16px;

  font-weight: 600;

  color: #fff;

  line-height: 1.25;

  letter-spacing: 0.01em;

}


.ig-navbar-subtitle {

  margin: 2px 0 0;

  padding: 0;

  font-family:
    'Noto Sans Odia',
    sans-serif;
    font-size:14px;

  font-weight: 500;

  color:fff;

  line-height: 1.5;

}


.ig-navbar-right {

  display: flex;

  align-items: center;

  gap: 1rem;

}


.ig-navbar-badge {

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.78rem;

  font-weight: 700;

  letter-spacing: 0.05em;

  color: #E8EEF7;

}


.ig-home-btn {

  display: inline-block;

  background: #fff;

  color: #023c77ff;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.82rem;

  font-weight: 700;

  line-height: 1.5;

  padding: 7px 16px;

  border-radius: 6px;

  text-decoration: none;

  transition:
    background 0.2s ease;

}


.ig-home-btn:hover {

  background: #DCE6F5;

  color: rgb(17, 88, 158);

}



/* ═══════════════════════════════════════
   PAGE
═══════════════════════════════════════ */

.fp-page {

  min-height: 100vh;

  display: flex;
  flex-direction: column;

  font-family: 'Noto Sans', Arial, sans-serif;

  background:
    linear-gradient(
      160deg,
      #F7FAFF 0%,
      #FFFFFF 50%,
      #F2F7FF 100%
    );

  position: relative;

  overflow: hidden;
}


/* Background orbs */

.fp-orb {

  position: fixed;

  border-radius: 50%;

  filter: blur(100px);

  opacity: 0.30;

  pointer-events: none;

  z-index: 0;

  animation: fp-orb-drift 12s ease-in-out infinite alternate;
}


.fp-orb-1 {

  width: 420px;
  height: 420px;

  background:
    radial-gradient(
      circle,
      #CFE3FA,
      transparent 70%
    );

  top: -140px;
  left: -100px;
}


.fp-orb-2 {

  width: 350px;
  height: 350px;

  background:
    radial-gradient(
      circle,
      #DCEBFF,
      transparent 70%
    );

  bottom: -100px;
  right: 5%;

  animation-delay: -6s;
}


@keyframes fp-orb-drift {

  0% {
    transform: translate(0,0) scale(1);
  }

  100% {
    transform: translate(25px,15px) scale(1.05);
  }

}


/* Grid */

.fp-grid {

  position: fixed;

  inset: 0;

  background-image:
    linear-gradient(
      rgba(24,67,129,0.022) 1px,
      transparent 1px
    ),
    linear-gradient(
      90deg,
      rgba(24,67,129,0.022) 1px,
      transparent 1px
    );

  background-size: 60px 60px;

  pointer-events: none;

  z-index: 0;
}


/* ═══════════════════════════════════════
   HEADER
═══════════════════════════════════════ */

.fp-header {

  position: relative;

  z-index: 10;

  display: flex;

  align-items: center;

  justify-content: space-between;

  padding: 8px 30px;

  min-height: 68px;

  background:
    linear-gradient(
      160deg,
      var(--navy) 0%,
      var(--navy-light) 100%
    );

  border-bottom:
    1px solid rgba(255,255,255,0.1);

  flex-wrap: wrap;

  gap: 8px;
}


.fp-header-left {

  display: flex;

  align-items: center;

  gap: 14px;
}


.fp-logo {

  height: 48px;

  width: auto;

  filter:
    drop-shadow(
      0 0 7px
      rgba(24,67,129,0.35)
    );
}


.fp-hname {

  font-size: 15px;

  font-weight: 700;

  color: #fff;

  letter-spacing: 0.02em;
}


.fp-hodia {

  font-size: 13px;

  font-family: 'Noto Sans Odia', sans-serif;

  color: rgba(255,255,255,0.9);

  margin-top: 2px;
}


.fp-header-right {

  display: flex;

  align-items: center;

  gap: 12px;
}


.fp-interface-tag {

  font-size: 12px;

  font-weight: 700;

  letter-spacing: 0.09em;

  color: rgba(255,255,255,0.75);
}


.fp-home-btn {

  padding: 7px 16px;

  background:
    linear-gradient(
      90deg,
      var(--navy),
      var(--navy-light)
    );

  color: #fff;

  font-size: 12px;

  font-weight: 700;

  border-radius: 6px;

  text-decoration: none;

  letter-spacing: 0.03em;

  box-shadow:
    0 3px 12px
    rgba(24,67,129,0.30);

  transition:
    transform .2s,
    filter .2s;
}


.fp-home-btn:hover {

  filter: brightness(1.08);

  transform: translateY(-1px);

}


/* ═══════════════════════════════════════
   MAIN
═══════════════════════════════════════ */

.fp-main {

  flex: 1;

  display: flex;

  align-items: center;

  justify-content: center;

  position: relative;

  z-index: 2;

  padding: 18px 15px;
}


/* ═══════════════════════════════════════
   CARD
═══════════════════════════════════════ */

.fp-card {

  width: 100%;

  max-width: 455px;

  background: #fff;

  border:
    1px solid var(--panel-border);

  border-radius: 20px;

  overflow: hidden;

  box-shadow:
    0 8px 35px
    rgba(24,67,129,0.16);

  animation:
    fp-card-in
    .6s
    cubic-bezier(.22,1,.36,1)
    both;
}


@keyframes fp-card-in {

  from {
    transform: translateY(22px) scale(.98);

    opacity: 0;
  }

  to {
    transform: translateY(0) scale(1);

    opacity: 1;
  }

}


/* Card header */

.fp-card-header {

  position: relative;

  padding: 13px 20px;

  text-align: center;

  background:
    linear-gradient(
      90deg,
      var(--navy),
      var(--navy-light)
    );

  color: #fff;

  font-size: 15px;

  font-weight: 800;

  letter-spacing: .12em;

  box-shadow:
    0 3px 16px
    rgba(24,67,129,.30);
}


/* ═══════════════════════════════════════
   ICON
═══════════════════════════════════════ */

.fp-icon-wrap {

  position: relative;

  display: flex;

  justify-content: center;

  padding-top: 15px;

  padding-bottom: 5px;
}


.fp-icon-ring {

  position: absolute;

  top: 50%;

  left: 50%;

  transform:
    translate(-50%,-50%);

  width: 76px;

  height: 76px;

  border-radius: 50%;

  background:
    conic-gradient(
      from 0deg,
      var(--navy),
      var(--navy-light),
      var(--navy)
    );

  opacity: .18;

  animation:
    fp-ring-spin
    5s linear infinite;
}


@keyframes fp-ring-spin {

  to {
    transform:
      translate(-50%,-50%)
      rotate(360deg);
  }

}


.fp-icon {

  width: 68px;

  height: 68px;

  border-radius: 50%;

  background: #EAF1FB;

  border:
    1px solid #C7D6EC;

  display: flex;

  align-items: center;

  justify-content: center;

  position: relative;

  z-index: 1;
}


/* ═══════════════════════════════════════
   DESCRIPTION
═══════════════════════════════════════ */

.fp-description {

  text-align: center;

  padding:
    2px 25px 8px;
}


.fp-description h2 {

  font-size: 17px;

  font-weight: 800;

  color: var(--navy);

  margin-bottom: 3px;
}


.fp-description p {

  font-size: 12.5px;

  line-height: 1.45;

  color: var(--text-muted);

}


/* ═══════════════════════════════════════
   ERROR
═══════════════════════════════════════ */

.fp-login-error {

  margin:
    0 25px 8px;

  padding:
    8px 11px;

  background:
    rgba(228,72,60,.07);

  border:
    1px solid rgba(228,72,60,.25);

  border-radius: 8px;

  color: var(--error);

  font-size: 12px;

  display: flex;

  align-items: center;

  gap: 7px;

  animation: fp-shake .35s ease;
}


@keyframes fp-shake {

  0%,100% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-4px);
  }

  75% {
    transform: translateX(4px);
  }

}


/* ═══════════════════════════════════════
   FORM
═══════════════════════════════════════ */

.fp-form {

  padding:
    6px 25px 10px;
}


.fp-field {

  margin-bottom: 12px;
}


.fp-label {

  display: block;

  font-size: 11px;

  font-weight: 700;

  color: var(--text-muted);

  letter-spacing: .06em;

  text-transform: uppercase;

  margin-bottom: 5px;
}


.fp-label span {

  color: var(--error);

  margin-left: 2px;
}


.fp-input-wrap {

  display: flex;

  align-items: center;

  background: var(--field-bg);

  border:
    1px solid var(--panel-border);

  border-radius: 9px;

  overflow: hidden;

  transition:
    border-color .2s,
    box-shadow .2s,
    background .2s;
}


.fp-input-wrap:focus-within {

  border-color: var(--navy-light);

  background: #fff;

  box-shadow:
    0 0 0 3px
    rgba(43,104,195,.14);
}


.fp-input-wrap.fp-err {

  border-color: var(--error);

  box-shadow:
    0 0 0 3px
    rgba(228,72,60,.10);
}


.fp-input-icon {

  flex-shrink: 0;

  margin-left: 12px;

  color: #9BAABD;
}


.fp-input-wrap input {

  flex: 1;

  border: none;

  outline: none;

  background: transparent;

  color: var(--text-primary);

  font-size: 13px;

   font-family: 'Noto Sans', Arial, sans-serif;

  padding: 11px 12px;
}


.fp-input-wrap input::placeholder {

  color: #A6B3C4;
}


.fp-error-msg {

  color: var(--error);

  font-size: 11px;

  margin-top: 4px;

  animation: fp-shake .3s ease;
}


/* ═══════════════════════════════════════
   BUTTON
═══════════════════════════════════════ */

.fp-action-row {

  display: flex;

  justify-content: flex-end;

  margin-top: 3px;
}


.fp-submit {

  padding:
    10px 24px;

  min-width: 135px;

  background:
    linear-gradient(
      90deg,
      var(--navy),
      var(--navy-light)
    );

  color: #fff;

  font-size: 13px;

  font-weight: 700;

  font-family: 'Noto Sans', Arial, sans-serif;

  border: none;

  border-radius: 9px;

  cursor: pointer;

  display: flex;

  align-items: center;

  justify-content: center;

  gap: 7px;

  box-shadow:
    0 4px 15px
    rgba(24,67,129,.32);

  transition:
    transform .2s,
    box-shadow .2s,
    filter .2s;
}


.fp-submit:hover:not(:disabled) {

  transform: translateY(-2px);

  box-shadow:
    0 7px 20px
    rgba(24,67,129,.42);

  filter: brightness(1.05);
}


.fp-submit:disabled {

  opacity: .7;

  cursor: not-allowed;
}


.fp-btn-spinner {

  width: 16px;

  height: 16px;

  display: inline-block;

  border:
    2px solid
    rgba(255,255,255,.4);

  border-top-color: #fff;

  border-radius: 50%;

  animation:
    fp-spin
    .7s linear infinite;
}


@keyframes fp-spin {

  to {
    transform: rotate(360deg);
  }

}


/* ═══════════════════════════════════════
   BOTTOM LOGIN
═══════════════════════════════════════ */

.fp-divider {

  height: 1px;

  background: var(--panel-border);

  margin:
    13px 0 10px;
}


.fp-login-line {

  text-align: center;

  font-size: 12px;

  color: var(--text-muted);
}


.fp-login-link {

  color: var(--navy-light);

  font-weight: 700;

  text-decoration: none;

  transition: color .2s;
}


.fp-login-link:hover {

  color: var(--blue-dark);

  text-decoration: underline;
}


/* ═══════════════════════════════════════
   FOOTER
═══════════════════════════════════════ */

.fp-footer {

  position: relative;

  z-index: 10;

  display: flex;

  justify-content: space-between;

  align-items: center;

  padding: 7px 30px;

  min-height: 34px;

  background:
    linear-gradient(
      160deg,
      var(--navy),
      var(--navy-light)
    );

  border-top:
    1px solid
    rgba(255,255,255,.08);

  font-size: 10px;

  color:
    rgba(255,255,255,.55);

  letter-spacing: .04em;

  flex-wrap: wrap;

  gap: 5px;
}


.fp-footer-brand {

  color: #8FB4E3;

  font-weight: 700;
}


/* ═══════════════════════════════════════
   RESPONSIVE
═══════════════════════════════════════ */

@media (max-width: 700px) {

  .fp-header {

    padding: 7px 15px;

  }

  .fp-logo {

    height: 42px;

  }

  .fp-hname {

    font-size: 11px;

  }

  .fp-hodia {

    font-size: 10px;

  }

  .fp-interface-tag {

    display: none;

  }

}


@media (max-width: 500px) {

  .fp-main {

    padding: 12px 10px;

  }

  .fp-card {

    max-width: 100%;

    border-radius: 16px;

  }

  .fp-form {

    padding:
      5px 18px 14px;

  }

  .fp-description {

    padding-left: 18px;
    padding-right: 18px;

  }

  .fp-login-error {

    margin-left: 18px;
    margin-right: 18px;

  }

  .fp-footer {

    padding:
      7px 12px;

    justify-content: center;

    text-align: center;

  }

}

`;
